import Vue from 'vue'
import Vuex from 'vuex' 
import workPlace from './modules/workPlace' 
import formwork from './modules/formwork' 
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: { 
    workPlace,
    formwork
  },
  getters,
})
